function DDUFooterFuel({value}) {
    return (
        <div class="relative col-span-3 flex items-center justify-center border-[#137fec33] border-[2px] rounded">
            <p class={`${value["pit-limiter"] === 1 ? "bg-[#0743c2]" : "bg-[#0a0f14]"} absolute top-[-13px] text-[12px] px-3 py-1 uppercase font-bold`}>FUEL</p>

            <div class="flex w-full justify-evenly">
                <div class="flex flex-col items-center w-[33%]">
                    <h1 class="text-[30px] font-bold">{value.fuel.toFixed(1)}</h1>
                    <p class="text-[10px] mt-[-10px]">Liters</p>
                </div>

                <div class="flex flex-col items-center w-[33%]">
                    <h1 class="text-[30px] font-bold">{value["fuel-x-lap"].toFixed(2)}</h1>
                    <p class="text-[10px] mt-[-10px]">Avg</p>
                </div>

                <div class="flex flex-col items-center w-[33%]">
                    <h1 class="text-[30px] font-bold">{(Math.floor(value["fuel-estimated-laps"] * 10) / 10).toFixed(1)}</h1>
                    <p class="text-[10px] mt-[-10px]">Laps</p>
                </div>
            </div>
        </div>
    );
}

export default DDUFooterFuel;